<script>
import ContactCard from 'components/elements/ContactCard.svelte';


import MsgCard from 'components/elements/MsgCard.svelte';



import SvelteSeo from 'svelte-seo';


const contacts = [
	{
		name: 'Mike Sanderson',
		title: 'Office Administrator',
		email: 'mike@atlantichockeygroup.com',
	},
	{
		name: 'Tracey Doucette',
		title: 'Executive Assistant',
		email: 'slapshot@nbnet.nb.ca',
	},
	{
		name: 'Dave Kennedy',
		title: 'Office Administrator',
		email: 'daveahg@nb.aibn.com',
	},
	{
		name: 'Patrick Bourgeois',
		title: 'Software Developer',
		email: 'helper@logicdraw.com',
	},
]


</script>


<style>
	

</style>



<SvelteSeo
	title='Contact | AHG Forms'
	description='Contact!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Contact
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container is-fullwidth">

		<div class="columns is-centered">

			<div class="column is-9-desktop is-10-tablet is-12-mobile">

				<MsgCard msg_show={true} msg_text={'If you have any questions - send us an email.'} msg_type={'error'} msg_forever={true} />

				<div class="columns is-variable is-3 is-mobile is-multiline is-centered">

					{#each contacts as contact}

						<div class="column is-6-desktop is-12-touch">

							<ContactCard {contact} />

						</div>

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>

<!-- email: donotreply@atlantichockeygroup.com -->

